import { useLocalStorage } from "@uidotdev/usehooks"

export type DropMarkerProps = null | undefined | 'from' | 'to'

export const IS_DROPPING_LOCAL_STORAGE_KEY = "INTERACTIVE_PLACE_ITEM_MENU"

export function useDropMarker() {
    return useLocalStorage<DropMarkerProps>(IS_DROPPING_LOCAL_STORAGE_KEY, undefined)
}